export default __webpack_public_path__ + "static/media/ep4collage3.6602ec78.jpg";